<div class="container mt-5">
    <div class="row justify-content-center">
        <div class="col-sm-12 col-md-8 col-lg-6">
            <!-- REPORT TITLE  -->
            <h2 class="mb-3">{{'reportsWizard.header.reportOf' | translate }} {{report.reportData.name}}</h2>

            <!-- GO BACK BUTTON -->
            <button type="button" class="btn btn-secondary mb-3" (click)="goBack()">
                <i class="pi pi-arrow-left"></i>
                {{ 'reportsWizard.reportsForm.goBack' | translate }}
            </button>

            <form [formGroup]="reportForm" (ngSubmit)="onSubmit()" class="p-3 border rounded">

                <!-- Vehicles field -->
                <div class="mb-3 ">
                    <div class="mb-3 d-flex align-items-center">
                        <label for="vehicles" class="me-2 mb-0">
                          {{ 'general.type' | translate }}
                        </label>
                      
                        <p-select 
                          [options]="types"
                          [(ngModel)]="selectedType"
                          optionLabel="label"
                          optionValue="value"
                          i18n-placeholder placeholder="{{'general.selectType' | translate}}"
                          formControlName="type">
                        </p-select>
                      </div>
                </div>
            </form>

            <!-- SUBMIT BUTTON -->
            <button type="submit" pButton (click)="toPhase3()"
                [disabled]="!reportForm.valid"
                class="btn btn-primary mt-3 w-100"
                [ngStyle]="{'background-color': '#C42C22', 'border-color': '#C42C22'}">{{ 'reportsWizard.reportsForm.next' | translate }}</button>
        </div>
    </div>
</div>